import { render, staticRenderFns } from "./ProductsInventoryDetails.vue?vue&type=template&id=31ba3795&lang=pug&"
import script from "./ProductsInventoryDetails.vue?vue&type=script&lang=js&"
export * from "./ProductsInventoryDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports